module.exports = require("lzutf8");